import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BugFilledSvg from "@ant-design/icons-svg/es/asn/BugFilled";
import AntdIcon from "../components/AntdIcon";
var BugFilled = function BugFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BugFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BugFilled.displayName = 'BugFilled';
}
export default /*#__PURE__*/React.forwardRef(BugFilled);